var Road = (function() {

    function _deleteRoads(ids) {
    return $.ajax({
        url: Url.action('api/roads'),
        type: 'DELETE',
        dataType: 'json',
        data: { ids: ids }
      })
        .done(() => _refreshTable(true, ids))
    .fail(() => {
         alert('Удаление невозможно: '  + (ids.length === 1 ? 'с данной дорогой' : 'с одной или несколькими дорогами')  + ' связаны участки облуживания, населенные пункты, протяженные объекты, точечные объекты, работы, ЧС, МС или КВН.');
     });
  };

  function _delete(ids) {
    if (ids.length > 0 && confirm('Вы действительно хотите удалить {0} записей?'.format(ids.length))) {
      _deleteRoads(ids, true);
    }
  };

  function _show(id) {
    const modal = ModalConductor.activate(RoadViewModal, id,
        (roadId) => {
          _deleteRoads([roadId]).done(() => modal.close());
        },
        (roadId) => {
          _showOnMap([roadId]);
        })
      .on('closed', (modalResult) => _refreshTable());
  };

  function _add() {
    ModalConductor.activate(RoadEditModal).on('closed', (modalResult) => _refreshTable());
  }

  function _showOnMap(ids) {
    if (ids.length > 0) {
      location.href = Url.map(ObjectTypes.Road, ids);
    }
  }

    function _refreshTable(resetChecked, deselectOnlyIds) {
        var table = $('#RoadListViewModelTable').DataTable();
        refreshTable(table, resetChecked, null, deselectOnlyIds);
    };

  return {
    show: _show,
    add: _add,
    del: _delete,
    showOnMap: _showOnMap
  };
}());
